<template>
  <div class="drugDosageList">
    <div style="padding-bottom: 20px">
      <el-radio-group v-model="conditions">
        <el-radio-button label="1">按天</el-radio-button>
        <el-radio-button label="2">按月</el-radio-button>
        <el-radio-button label="3">按年</el-radio-button>
      </el-radio-group>
      <!--      <el-button @click="goback" style="float: right">返回</el-button>-->
    </div>
    <div style="margin-bottom: 20px">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
        <el-form-item label="日期区间" label-width="70px" v-if="conditions === '1'">
          <el-date-picker
              @input="search"
              v-model="searchForm.dayTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width: 220px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份区间" label-width="70px" v-if="conditions === '2'">
          <el-date-picker
              @input="search"
              v-model="searchForm.monthTime"
              value-format="yyyy-MM-dd"
              type="monthrange"
              style="width: 220px"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="年份" label-width="40px" v-if="conditions === '3'">
          <el-date-picker
              @input="search"
              v-model="searchForm.startYear"
              type="year"
              value-format="yyyy"
              style="width: 220px"
              placeholder="开始年份"
              unlink-panels>
          </el-date-picker>
          -
          <el-date-picker
              @input="search"
              v-model="searchForm.endYear"
              type="year"
              style="width: 220px"
              value-format="yyyy"
              unlink-panels
              placeholder="结束年份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="代理商" label-width="60px">
          <el-select v-model="searchForm.operator" @change="operatorClick" placeholder="请选择">
            <el-option
                v-for="item in operatorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药房" label-width="60px">
          <el-select v-model="searchForm.pharmacy" @change="tabConditions" placeholder="请选择">
            <el-option
                v-for="item in pharmacyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="药品编码" label-width="80px">
          <el-input style="width: 140px"  @input="search" clearable v-model="searchForm.drugCode" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="date"
            :label="timeName">
          <template slot-scope="scope">
            <span v-if="conditions==='1'">{{scope.row.date}}</span>
            <span v-if="conditions==='2'">{{scope.row.year}}-{{scope.row.month}}</span>
            <span v-if="conditions==='3'">{{scope.row.year}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="drugName"
            label="药品名称"
            width="100">
        </el-table-column>
        <el-table-column
            prop="factoryCode"
            align="center"
            label="药厂名称">
        </el-table-column>
        <el-table-column
            prop="dose"
            align="center"
            label="日均用量">
        </el-table-column>
        <el-table-column
            prop="unit"
            align="center"
            label="单位">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            prop="prescriptionDaysAmount"-->
        <!--            align="center"-->
        <!--            label="处方天数">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            prop="cupAmount"-->
        <!--            align="center"-->
        <!--            label="杯数">-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
        <div style="margin-top: 20px">
          <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                      @handleCurrentChange='handleCurrentChange'></Pagination>
        </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
export default {
  name: "drugDosageList",
  data() {
    return {
      conditions: "1",
      pickerType:'date',
      searchForm:{
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        code:''
      },
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      tableData:[],
      splitData:[],
      operatorOptions:[],
      pharmacyOptions:[],
      timeName:'日期'
    }
  },
  components: {
    //someComponent
    Pagination,
  },
  methods: {
    //
    tabConditions(){
      let url = ''
      let data = {}
      switch (this.conditions) {
        case "1":
          url = '/Statistics/PharmacyStatistics/GetDrugDaySale'
          data = {
            pharmacyId: this.searchForm.pharmacy,
            startDate: this.searchForm.dayTime[0],
            endDate: this.searchForm.dayTime[1],
            cupTypeCode: this.searchForm.cupTypeCode,
          }
          this.timeName='日期'
          break;
        case "2":
          url = '/Statistics/PharmacyStatistics/GetDrugMonthSale'
          data = {
            pharmacyId: this.searchForm.pharmacy,
            startDate: this.searchForm.monthTime[0],
            endDate: this.searchForm.monthTime[1],
            cupTypeCode: this.searchForm.cupTypeCode,
            orderby:1,
            take:10,
          }
          this.timeName='月份'
          break;
        default:
          data = {
            pharmacyId: this.searchForm.pharmacy,
            startYear: this.searchForm.startYear,
            endYear: this.searchForm.endYear,
            cupTypeCode:this.searchForm.cupTypeCode,
            orderby:1,
            take:10,
          }
          this.timeName='年份'
          url = '/Statistics/PharmacyStatistics/GetDrugYearSale'
      }
      this.init(url, data)
    },
    search(){
      this.tabConditions()
    },
    getitems(target,page,pagesize){ // 前端分页
      let start=(page-1)*pagesize;
      let end=page*pagesize>target.length?target.length:page*pagesize;
      let result=[];
      for(start;start<end;start++){
        result.push(target[start]);
      }
      return result;
    },

    init(url, data) {
      this.axios
          .get(url, {params: data})
          .then((res) => {
            this.splitData = res.list
            this.tableData=this.getitems(this.splitData,this.currPage,this.pageSize)
            this.total=res.count
            this.tableData.forEach(item=>{
              if(item.date){
                item.date=this.dayjs(item.date).format('YYYY/MM/DD HH:mm')
              }
            })
          })
    },
    operatorList(){
      this.axios
          .get('/api/Dic?dicType=6')
          .then((res) => {
          this.operatorOptions=res
            this.operatorOptions.forEach(item=>{
              item.label=item.name
              item.value=item.id
            })
          })
    },
    operatorClick(e){
      let data={
        operatorId:e,
        page:'1',
        pageSize:'1000'
      }
      this.axios
          .get('/api/Pharmacy/GetByOperator',{params:data}).then((res) => {
        this.pharmacyOptions=res.list
        this.pharmacyOptions.forEach(item=>{
          item.label=item.name
          item.value=item.id
        })
      })
    },
    // ----------分页控制-------------
    clear(){
      this.searchForm={
        dayTime: [],
        monthTime: [],
        startYear: '2020',
        endYear: '2021',
        code:''
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.tableData=this.getitems(this.splitData,this.currPage,this.pageSize)
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.tableData=this.getitems(this.splitData,this.currPage,this.pageSize)
    },
  },
  mounted() {
    //
    this.operatorList()
  }
}
</script>

<style lang="scss" scoped>
.drugDosageList {

}
</style>